import { get } from "lodash";

export function getAggregations(aggs) {
  if (!aggs || typeof aggs !== "object" || Object.keys(aggs).length === 0) {
    return aggs;
  }

  aggs["in_production"] = {
    ...aggs["in_production"],
    doc_count:
      getAggCount(aggs, "pending_payment") +
      getAggCount(aggs, "ready_to_print") +
      getAggCount(aggs, "printing"),
  };

  return aggs;
}

export function getAggValue(aggs, key) {
  return getAggCount(aggs, key, "value");
}

export function getAggCount(aggs, key, suffix = "doc_count") {
  return get(aggs, `${key}.${suffix}`) || 0;
}

const mapOrderDirectives = {
  withMappingOrder: "mappingOrder",
  withShippingLabel: "orderId",
  withCustomer: "buyerName",
  withTeam: "teamName",
  withSupplier: "supplier",
  withStore: "store",
  withProduct: "product",
  withCarrier: "carrier",
  withTracking: "tracking",
  withFulfillment: "fulfillment",
  withOrderGrand: "revenue",
  withOriginalProduct: "product",
  withTaskStatus: "taskStatus",
  withLastOrderProgress: "status",
  withWarningAddress: "originId",
};

export function mapOrderDirectivesFn(options) {
  const opts = options ?? [];

  const optsObj = options.reduce((acc, item) => {
    acc[item] = true;
    return acc;
  }, {});

  const result = {};
  for (const [key, label] of Object.entries(mapOrderDirectives)) {
    result[key] = !!optsObj[label];
  }

  return result;
}
